import React from "react";
import { Link } from "react-router-dom";

export const MenuItem = ({ arr, onClose }) => {
 
  return (
    <div 
      className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-48 bg-white/5 backdrop-blur-md border border-white/10 shadow-2xl z-40 rounded-xl overflow-hidden"
      onMouseLeave={onClose}
    >
      <ul className="py-1">
        {arr.map((item, index) => (
          <li 
            key={index} 
            onClick={onClose}
          >
            <Link to={item.to} className="block px-4 py-2 hover:bg-gray-200/50 cursor-pointer transition-colors rounded-xl">{item.text}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};